import { ReactNode, useEffect } from 'react';

import EmptyState from '@ergeon/core-components/exports/EmptyState.ts';
import { ExclamationTriangleIcon } from '@ergeon/icons/hero/outline';

import { useSentry } from '@/sentry/context';

export interface ErrorProps {
  title?: string;
  description?: string;
  error?: Error;
  children?: ReactNode;
}

const actionsOf = (children: ReactNode) => (children ? <>{children}</> : undefined);

export default function BaseError({ title, description, error, children }: ErrorProps) {
  const Sentry = useSentry();

  useEffect(function captureExceptionOnce() {
    if (error) Sentry.captureException(error);
  }, [error, Sentry]);

  const actions = actionsOf(children);

  return (
    <div className="flex h-screen items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="flex flex-col items-center gap-4">
        <EmptyState
          actions={actions}
          description={description ?? ''}
          icon={<ExclamationTriangleIcon />}
          title={title ?? ''} />
        {error?.message &&
          <p className="paragraph-3 text-gray-500 dark:text-gray-400">Original error message: {error.message}</p>
        }
      </div>
    </div>
  );
}
